import AppAction from "../../organism/App/action";
import { LocalizationType } from "../../organism/App/state";
import { ICallbackProps } from "ui/molecule/resetPassword/ResetPasswordUI";

export default {
  onLocalizationChange: (localization: LocalizationType) =>
    AppAction.setLocalStorageLocalization(localization),
} as ICallbackProps;
